/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-175840.jpg";

import screenOne from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-175734.jpg";
import screenTwo from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-175559.jpg";
import screenThree from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-175704.jpg";
import screenFour from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-175918.jpg";
import screenFive from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-222107.jpg";
import screenSix from "assets/images/spaceeonscreens/com.oculus.vrshell-20240309-222139.jpg";

function Presentation() {
  return (
    <>
      <MKBox
        background="#FFFFFF"
        minHeight="75vh"
        color="black"
        backgroundColor="black"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          backgroundColor: "black",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Space Eon VR{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <p>First Person Combat and 3D Space Ship Fighting Game</p>
              <p>Target Release Date: Q4 2024</p>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Container backgroundColor="black" background="#FFFFFF">
        <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
          <img src={screenOne} alt="Screenshot One" width={"300px"} height={"200px"} />
          <img src={screenTwo} alt="Screenshot Two" width={"300px"} height={"200px"} />
          <img src={screenThree} alt="Screenshot Three" width={"300px"} height={"200px"} />
          <img src={screenFour} alt="Screenshot Four" width={"300px"} height={"200px"} />
          <img src={screenFive} alt="Screenshot Five" width={"300px"} height={"200px"} />
          <img src={screenSix} alt="Screenshot Six" width={"300px"} height={"200px"} />
        </Grid>
      </Container>
      <Container color="black" backgroundColor="black" background="#FFFFFF">
        <Grid container item xs={6} lg={6} justifyContent="center" mx="auto" color="black">
          <MKTypography
            background="#FFFFFF"
            backgroundColor="black"
            variant="body1"
            color="black"
            textAlign="center"
            px={{ xs: 6, lg: 12 }}
            mt={1}
          >
            <p>Website Under Construction</p>
            <p>Contact:</p>
            <p>Goblin Studios</p>
            <p>170 Rajput Way, Saskatoon SK</p>
            <p>goblinstudiosk@gmail.com</p>
          </MKTypography>
        </Grid>
      </Container>
    </>
  );
}

export default Presentation;
